import { createFileRoute } from "@tanstack/react-router";
import {
    kennelMessagesRoute,
    KennelMessagesPage,
} from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/messages/")({
    ssr: kennelMessagesRoute.ssr,
    head: kennelMessagesRoute.head,
    component: KennelMessagesPage,
});
